export var VideoElementReadyState;
(function (VideoElementReadyState) {
    VideoElementReadyState[VideoElementReadyState["HaveNothing"] = 0] = "HaveNothing";
    VideoElementReadyState[VideoElementReadyState["HaveMetadata"] = 1] = "HaveMetadata";
    VideoElementReadyState[VideoElementReadyState["HaveCurrentData"] = 2] = "HaveCurrentData";
    VideoElementReadyState[VideoElementReadyState["HaveFutureData"] = 3] = "HaveFutureData";
    VideoElementReadyState[VideoElementReadyState["HaveEnoughData"] = 4] = "HaveEnoughData";
})(VideoElementReadyState || (VideoElementReadyState = {}));
